import { TextButton } from '../index';
import { BreadcrumbList } from './Breadcrumb.style';

export const Breadcrumb = ({ content }: {content: any}) => {
  return (
    <BreadcrumbList as='nav'>
      <ul>
        {content.map((p: any, index: number) => (
          <li key={index}>
            {index !== content.length - 1
              && <TextButton to={p.slug}>{p.text}</TextButton>
            || p.text
            }
          </li>
        ))}
      </ul>
    </BreadcrumbList>
  );
};
